export const faqData: any[] = [
  {
    answer:
      'Signing up for an Arcadia account allows us to check your eligibility and enroll you in our community solar program. You’ll get updates on how your solar farm is performing, along with monthly savings notifications.',
    name: 'signup',
    question: 'Why do I need an Arcadia account?',
  },
  {
    answer: (() => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <p>
          Community solar programs make it easy to access clean energy and solar savings - without
          the costly, logistical barriers associated with private solar panels.
        </p>
        <p>
          In Ohio, our program is a new initiative in partnership with Google and EDP Renewables
          that introduces a new way to support clean energy. They're building 500 megawatts of solar
          power across approximately 80 solar projects, and have partnered with Arcadia to allocate
          a portion of the proceeds from those projects to help over 25,000 households with a high
          energy cost burden.
        </p>
      </div>
    ))(),
    name: 'communitysolar',
    question: 'What is Arcadia’s community solar program?',
  },
  {
    answer:
      'A solar farm (or solar project) is a large collection of solar panels that absorb energy from the sun, convert it into electricity, and send that electricity to the power grid for distribution and consumption by customers like you.',
    name: 'solarfarm',
    question: 'What is a solar farm?',
  },
  {
    answer:
      'It’s entirely free to sign up and there are no ongoing costs to participate. If you qualify as a low- or moderate-income household we will be able to connect you to a solar farm that generates monthly savings on your utility bill.',
    name: 'cost',
    question: 'Does this cost anything?',
  },
  {
    answer:
      'You’ll provide us with information about your utility account so that we can maximize your savings and confirm your qualification for the program.',
    name: 'whatnext',
    question: 'What happens next?',
  },
  {
    answer: (() => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        If you don't qualify, there is unfortunately no other option to sign up for community solar
        with Arcadia in Ohio at this time. We will keep you posted if Ohio establishes additional
        opportunities for more folks to sign up for community solar in the future.
      </div>
    ))(),
    name: 'qualify',
    question: 'What if I don’t qualify as a low- or moderate-income household?',
  },
];
